<div class="esvrDisputeContainer">
  <div class="arrow-up"></div>
  <h1>Open Dispute</h1>

  <p>
    Please specify the reason for Reject.
  </p>

  <div class="cmn-forms textArea">
    <mat-form-field class="confirmationContainer__reasonInput cmn-txtarea" appearance="outline" floatLabel="never">
      <textarea placeholder="Write..." matInput [formControl]="rejectionReason"></textarea>
      <mat-error></mat-error>
    </mat-form-field>
  </div>
  <div class="actioncontainer">
    <button *ngIf="status !== ESVRStatus.PendingApproval" [disabled]="rejectionReason.invalid" mat-raised-button
      type="button" (click)="onHold()" class="cmn-draft-btn">
      Put On-hold
    </button>
    <button [disabled]="rejectionReason.invalid" mat-raised-button type="button" (click)="reject()"
      class="cmn-green-btn">
      <span class="material-icons btn-close">highlight_off</span>Reject
    </button>
  </div>
</div>